import * as Yup from "yup";

export default Yup.object({
  termsAndCondition: Yup.boolean()
    // .required("The terms and conditions must be accepted.")
    .oneOf([true], "Must Accept Terms and Conditions"),
  termsAndConditionsId: Yup.string(),
});
